import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../Assets/logo.png";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Services", path: "/service" }, // ✅ ADDED
    { name: "Career", path: "/careers" },
    { name: "Pricing", path: "/pricing" },
  ];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 w-[95%] max-w-6xl rounded-xl transition-all duration-300 ${
        scrolled
          ? "bg-white shadow-md border border-gray-200"
          : "bg-white/80 backdrop-blur"
      }`}
    >
      <div className="flex items-center justify-between px-6 py-3">

        {/* LOGO */}
        <Link to="/" className="flex items-center">
          <img src={Logo} alt="logo" className="h-8" />
        </Link>

        {/* DESKTOP NAV */}
        <nav className="hidden md:flex items-center gap-6">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className={`relative font-medium transition ${
                location.pathname === item.path
                  ? "text-blue-600"
                  : "text-gray-700 hover:text-blue-600"
              }`}
            >
              {item.name}

              {/* Active underline */}
              {location.pathname === item.path && (
                <span className="absolute left-0 -bottom-1 w-full h-[2px] bg-blue-600"></span>
              )}
            </Link>
          ))}
        </nav>

        {/* ACTION BUTTONS */}
        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/login"
            className="text-sm text-gray-600 hover:text-black"
          >
            Login
          </Link>

          <Link to="/dashboard">
            <button className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
              Dashboard
            </button>
          </Link>
        </div>

        {/* MOBILE MENU BUTTON */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-2xl"
        >
          ☰
        </button>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="md:hidden bg-white rounded-b-xl shadow-lg p-4">
          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.path}
              className="block py-2 text-gray-700"
              onClick={() => setOpen(false)}
            >
              {item.name}
            </Link>
          ))}

          <Link to="/login" className="block py-2">
            Login
          </Link>

          <Link to="/dashboard" className="block py-2 font-semibold text-blue-600">
            Dashboard
          </Link>
        </div>
      )}
    </header>
  );
}